import React from 'react'
import MaterialSymbol from '../material-symbol'

const EmojiObjects = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="emoji_objects" {...props} />
))

EmojiObjects.displayName = 'EmojiObjects'

export default EmojiObjects
